import React, { Component } from "react";
import { Link } from "react-router-dom";
import { decode as base64_decode, encode as base64_encode } from "base-64";

import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import HelpModal from "./HelpModal";
import { Tooltip,Button, Image, Typography} from "antd";
import Cookies from "universal-cookie";
import conf from "../config";
import { Helmet } from "react-helmet";
import drive7Icon from "../../src/assets/images/drive7.ico";
import awtlIcon from "../../src/assets/images/awtl.ico";
import starlingIcon from "../../src/assets/images/starling.ico";
import secureIcon from '../../src/assets/images/secure.ico';
const { Title } = Typography;
class SecureTrackMain extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    // this.mapShow = Number(
    //   JSON.parse(JSON.stringifythis.cookies.get("mapShow"))
    // );
    this.state = {};
    this.showLaunchingItems = {
      livetracking: false,
      dashboard: false,
      historytracking: false,
      detailtracking: false,
      parentalertreportlist: false,
      master: false,
      AdvanceDashboard: false,
      vehiclelist: false,
      parentreport: false,
      maintenancedashboard: false,
      showHelpModal: false,
      showLaunchingDashboard: 2,
    };
    // console.log(this.mapShow);

  
  }

  componentDidMount() {
    // this.updateDashboard(1);
  }

   updateIcons = () => {
    if (conf.project === "drive7") {
      return {
        favicon: drive7Icon,
        appleTouchIcon: drive7Icon,
      };
    } else if (conf.project === "awtltrack") {
      return {
        favicon: awtlIcon,
        appleTouchIcon: awtlIcon,
      };
    } else if (conf.project === "starlingeye") {
      return {
        favicon: starlingIcon,
        appleTouchIcon: starlingIcon,
      };
    } else if (conf.project === "trackeazy") {
      return {
        favicon: "/favicon.ico",
        appleTouchIcon: "/favicon.ico",
      };
    } else if (conf.project === "securetrack") {
      return {
        favicon: secureIcon,
        appleTouchIcon: secureIcon,
      };
    }else {
      return {
        favicon: "/favicon.ico",
        appleTouchIcon: "/favicon.ico",
      };
    }
  };

    updateTitle = () => {
    if (conf.project === "drive7") {
      return "Drive7";
    } else if (conf.project === "awtltrack") {
      return "AWTL";
    } else if (conf.project === "starlingeye") {
      return "Starlingeye";
    } else if (conf.project === "trackeazy") {
      return "Trackeazy";
    } else if (conf.project === "securetrack") {
      return "SecureTrack";
    } else {
      return "Trackeazy";
    }
  };

  render() {
    const formItemStyle = { marginBottom: "2px", marginTop: "2px" };
    const { favicon, appleTouchIcon } = this.updateIcons();

    return (
        <>
      <Helmet>
          <title>{this.updateTitle()}</title>
          <link rel="icon" href={favicon} />
          <link rel="apple-touch-icon" href={appleTouchIcon} />
        </Helmet>
 
  
     <div className="app-container">
      <div className="login-overlay">
      {/* Logo Section */}
      <div className="container mt-4" style={{ textAlign: 'end' }}>
        <Image
          src={require('../assets/images/swd-dashboard-st.png')}
          alt="SecureTrackX"
          preview={false}
          className="mainLogo"
        />
      </div>

      {/* Login Circles */}
      <div className="login-section">
        {/* SecurePath Circle */}
        <div className="maincircle-1 login-circle">
          <div className="mainbgwhite">
            <Image
              src={require('../assets/images/SecurePath.png')}
              alt="SecurePath"
              preview={false}
              className="circle-logo"
            />
            <Button
              type="primary"
              danger
              shape="round"
              size="small"
              onClick={() => window.open('https://sira.securepath.ae', '_blank')
              }
              className="btn-rounded"
            >
              LOGIN
            </Button>
          </div>
        </div>

        {/* SecureTrackX Circle */}
        <div className="maincircle-2 login-circle-2 large">
          <div className="mainbgblack">
            <Image
              src={require('../assets/images/swd-dashboard-st.png')}
              alt="SecureTrackX"
              preview={false}
              className="circle-logo large-logo"
            />
            {/* <Link to="/SecureTrackLogin"> */}
              <Button type="primary" danger shape="round" size="small"
                onClick={() => {
                  this.props.navigate("/SecureTrackLogin");
                }}
                className="btn-rounded"
              >
                LOGIN
              </Button>
            {/* </Link> */}
          </div>
        </div>

        {/* SecureTrack Basic Circle */}
        <div className="maincircle-3 login-circle">
          <div className="mainbggreen text-center">
            <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white'}}>
              SECURETRACK BASIC
            </Title>
            <Button
              type="default"
              shape="round"
              size="small"
              className="login-button green btn-rounded"
              // onClick={() => window.open('https://sira.securepath.ae', '_blank') }
            >
              LOGIN
            </Button>
          </div>
        </div>
      </div>

      {/* Approved By Section */}
      <Title level={5} className="approved-title">
        SERVICE RELATED
      </Title>
      <div className="approved-section">
        <div className="approved-logos">
          <Image src={require('../assets/images/SecurePath.png')} preview={false} height={75} />
          <Image src={require('../assets/images/govdubai.png')} preview={false} height={75} />
          <Image src={require('../assets/images/siradubai.png')} preview={false} height={75} />
          <Image src={require('../assets/images/RTA_Dubai_logo.png')} preview={false} height={75} />
          <Image src={require('../assets/images/TDRA-final-logo.png')} preview={false} height={75} />
          <Image src={require('../assets/images/Dubai-police-logo-vector.png')} preview={false} height={75} />
        </div>
      </div>
    </div>
   </div>
   </>
    );
  }
}
SecureTrackMain.contextType = StoreContext;
export default observer(withRouter(SecureTrackMain));
